import type { DeepRequired } from '../fixtures.types'

const revenueEventCandidate: DeepRequired<RevenueEventCandidate> = {
  __typename: 'RevenueEventCandidate',
  case_type: null,
  case_status: null,
  confidence_score: null,
  confirmed: null,
  matched_at: null,
  revenue_event: {
    __typename: 'RevenueEvent',
    case_id: null,
    gross_fee: null,
    initial_commission: null,
    net_fee: null,
    payment_date: null,
    payment_direction: null,
    renewal_commission: null,
    revenue_type: null,
  },
  details: {
    __typename: 'RevenueEventDetails',
    advisor_name: null,
    client_names: [],
    completion_date: null,
    lender: null,
    loan_amount: null,
    org_name: null,
    policy_number: null,
    premium_amount: null,
    premium_frequency: null,
  },
}

export default revenueEventCandidate
